import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';

export const fetchCommodityCodes = createProvider(api.fetchCommodityCodes)
  .andThen((res) => res)
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch commodity codes aborted');
    } else {
      console.error('Fetch commodity codes was failed:', error);
    }
    throw error;
  });
